import { render, staticRenderFns } from "./ilogsettings.vue?vue&type=template&id=36fd399b&"
import script from "./ilogsettings.vue?vue&type=script&lang=js&"
export * from "./ilogsettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports